import { useModelContext } from '@app/contexts/model';
import { UserData } from '@app/models/Users.model';
import { columnDefs } from '@app/modules/SelfConfig/factory/columnDefs';
import { TextField } from '@mui/material';
import { GridOptions, GridReadyEvent, RowDoubleClickedEvent, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { observe } from 'mobx';
import React, { FunctionComponent, useEffect } from 'react';
import { useStorageUserListContext } from '../../contexts/storage';
import './Table.scss';

export const Table: FunctionComponent = () => {
    const { usersListStore } = useStorageUserListContext();
    const { usersModel } = useModelContext();

    const gridOptions: GridOptions<UserData> = {
        columnDefs: columnDefs(),
        getRowId(data) {
            return data.data._id;
        },
        onGridReady(event: GridReadyEvent): void {
            usersListStore.gridApi = event.api;
            usersListStore.gridApi.sizeColumnsToFit();
            if (usersModel.dataUsers.length) {
                event.api.setGridOption('rowData', usersModel.dataUsers);
            }
        },
        rowSelection: 'single',
        suppressRowClickSelection: false,
        onSelectionChanged(event: SelectionChangedEvent): void {
            usersListStore.gridApi.getSelectedRows().forEach((item: UserData) => {
                usersListStore.editedUserID = item._id;
                usersListStore.userLogin = item.email;
                usersListStore.mainLanguagesChosenIdSet.replace(item.language_source);
                usersListStore.targetLanguagesChosenIdSet.replace(item.language_target);
                usersListStore.canSaveTranslation = item.approval;
                usersListStore.userPrivilege = item.privilege;
            });
        },
        onRowDoubleClicked(event: RowDoubleClickedEvent): void {
            const item = event.data as UserData;

            usersListStore.editedUserID = item._id;
            usersListStore.userLogin = item.email;
            usersListStore.mainLanguagesChosenIdSet.replace(item.language_source);
            usersListStore.targetLanguagesChosenIdSet.replace(item.language_target);
            usersListStore.canSaveTranslation = item.approval;
            usersListStore.userPrivilege = item.privilege;

            usersListStore.handleOpen();
        },
        stopEditingWhenCellsLoseFocus: true
    };

    useEffect(() => {
        const removeObserve = observe(usersModel.dataUsers, (changeData) => {
            const api = usersListStore.gridApi;
            if (!api) {
                return;
            }
            api.setGridOption('rowData', changeData.object);
        });

        let listener = () => {
            usersListStore.gridApi.sizeColumnsToFit();
        };
        window.addEventListener('resize', listener);

        return () => {
            removeObserve();
            usersListStore.gridApi = null;
            window.removeEventListener('resize', listener);
        };
    });

    return (
        <div>
            <TextField
                type='text'
                size='small'
                className={'nextWordsKey'}
                variant='outlined'
                label='Search...'
                sx={{ mb: 2 }}
                onChange={(event) => {
                    usersListStore.gridApi.setGridOption('quickFilterText', event.target.value);
                }}
            />
            <AgGridReact className={'table_users table_users--box ag-theme-balham'} rowData={usersModel.dataUsers} gridOptions={gridOptions as any} />
        </div>
    );
};
